import { apiClient } from './client';

export interface MessageHit {
  id: string;
  channelId?: string;
  authorId?: string;
  senderId?: string;
  recipientId?: string;
  createdAt: string;
  rank: number;
  content: string;
}

export interface GlobalSearchResult {
  messages: MessageHit[];
  dms: MessageHit[];
}

export interface PublicChannelHit {
  id: string;
  name: string;
  displayName: string;
  topic: string | null;
  avatarUrl: string | null;
}

export interface PublicUserHit {
  id: string;
  username: string;
  displayName: string;
  avatarUrl: string | null;
  bio: string | null;
  status: string;
}

export const searchApi = {
  global: (q: string, limit = 30) =>
    apiClient.get<GlobalSearchResult>('/api/search/global', { params: { q, limit } }).then((r) => r.data),
  inChannel: (channelId: string, q: string, limit = 30) =>
    apiClient.get<MessageHit[]>(`/api/search/channel/${channelId}`, { params: { q, limit } }).then((r) => r.data),
  channels: (q: string, limit = 30) =>
    apiClient.get<PublicChannelHit[]>('/api/search/channels', { params: { q, limit } }).then((r) => r.data),
  users: (q: string, limit = 30) =>
    apiClient.get<PublicUserHit[]>('/api/search/users', { params: { q, limit } }).then((r) => r.data),
};
